import React, { Component } from "react";
import apiClient from "../lib/apiClient";

class Ranking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      songs: [],
      isLoading: true,
      countdown: 0,
      gigLength: 0
    }
  }

  timer = () => {
    location.reload();
  }

  async componentDidMount() {
    this.countdown = setTimeout(this.timer, 30000);
    const songs = await apiClient.getGigSongs();
    let maxVotesCount = 0;
    [...songs].map(song => song.votes.map(vote => vote.username === 'Max' ? maxVotesCount++ : ''));
    this.setState({ songs, isLoading: false, gigLength: maxVotesCount })
  }

  markSongPlayed = async (event) => {
    const id = event.target.value;
    await apiClient.playedSong(id);
    location.reload();
  }

  render() {
    const { isLoading, gigLength } = this.state;
    const compare = (a, b) => {
      if ( a.votes.length > b.votes.length ){
        return -1;
      }
      if ( a.votes.length < b.votes.length ){
        return 1;
      }
      return 0;
    }

    const songs = [...this.state.songs].sort(compare).splice(0, gigLength);
    
    if (isLoading) {
      <p className="main h-2/3">Loading...</p>
    }
    
    return (
      <div className="w-80 text-left lg:flex lg:justify-center">
        <div className="lg:ml-80">
          <p className="text-xl font-bold">Properes</p>
          <hr className="border border-gray-700 my-3 w-72" />
            {songs.sort(compare).map((song, index) => {
              const { artist, name, votes, pageNum, _id, played } = song;
              if (!played) {
                if (votes.length < 2) {
                  return <div className="flex justify-start pb-3 text-left" key={index}>
                    <button className="bg-red-300 w-10 h-10 px-2 rounded-md mr-5" value={_id} onClick={this.markSongPlayed}>Fet</button>
                    <p><span className="font-bold">{artist} - {name} </span> Pàg. {pageNum} - {votes.length} vots (
                      {votes.map((vote, index) => <span key={index}>{vote.username}</span>)}
                      )</p>
                  </div>
                } else {
                  return <div className="flex justify-start pb-3 text-left" key={index}>
                    <button className="bg-red-300 w-10 h-10 px-2 rounded-md mr-5" value={_id} onClick={this.markSongPlayed}>Fet</button>
                    <p><span className="font-bold">{artist} - {name} </span> Pàg. {pageNum} - {votes.length} vots (
                      {votes.map((vote, index) => {
                        if (index < votes.length - 1) {
                          return <span key={index}>{vote.username}, </span>
                        } else {
                          return <span key={index}>{vote.username}</span>
                        }
                      })})</p>
                    </div>
                }
              } else {
                return ""
              }
            })}               
        </div>

        <div className="lg:ml-12">
          <p className="font-bold text-red-400 pt-5 text-xl">Fetes</p>
          <hr className="border border-red-300 my-3 w-72"/>
          {songs.map((song, index) => {
            const { artist, name, votes, pageNum } = song;
            if (song.played) {
              if (votes.length < 2) {
                  return <div className="flex justify-between pb-3" key={index}>
                    <p className="text-red-400"><span className="font-bold">{artist} - {name} </span> Pàg. {pageNum} - {votes.length} vots (
                      {votes.map((vote, index) => <span key={index}>{vote.username}</span>)}
                      )</p>
                  </div>
                } else {
                  return <div className="flex justify-between pb-3" key={index}>
                    <p className="text-red-400"><span className="font-bold">{artist} - {name} </span> Pàg. {pageNum} - {votes.length} vots (
                      {votes.map((vote, index) => {
                        if (index < votes.length - 1) {
                          return <span key={index}>{vote.username}, </span>
                        } else {
                          return <span key={index}>{vote.username}</span>
                        }
                      })}
                    )</p>
                    </div>
                }
            } else {
              return "";
              }
            })}
        </div>
      </div>
    )
  }
}

export default Ranking;